import api from './api';

export async function getTokens(
  idUser: number,
  page: number,
  limit: number,
  token: string,
): Promise<any> {
  let baseURL = `/tokens/exchange?limit=${limit}`;
  if (idUser) {
    baseURL = `${baseURL}&idUser=${idUser}`;
  }
  if (page) {
    baseURL = `${baseURL}&page=${page}`;
  }
  const response = await api.get(baseURL, {
    headers: {
      'x-access-token': token,
    },
  });

  return response.data;
}
